module.exports = __webpack_public_path__ + "54ae6f95d4c3b43d2cd5d10448cf1448.png";